import authentication from '@/services/authentication'

export default async (app, inject) => {
  // do not init the store for an iframe (embed kintell card)
  if (app.app.$inIframe) {
    return
  }

  const $authentication = authentication(app)

  // set the token from the query if it's set
  const query = app.route.query
  if (query.token && !app.app.$auth.loggedIn && !app.app.$auth.busy) {
    try {
      await app.app.$auth.setUserToken(query.token)
    } catch (e) {
      app.app.$logger.warn('Failed to set user from token')
    }
  }

  if (process.client) {
    $authentication.initializeStateWatchers()
  }

  inject('authentication', $authentication)
}
